import api from "../../index";

export const GetAllLeadsApi = (params) => api.get(`SalesDashboard/Get-All-Sales-Lead?${params}`);
export const GetAllSourceApi = () => api.get('SalesDashboard/GetAll-Sales-Source');
export const AddUpdateLeadApi = (data) => api.post('SalesDashboard/Add-Update-Sales-Lead', data);
export const UpdateLeadStatusApi = (data) => api.patch('SalesDashboard/Update-Sales-Lead-Status', data);
export const ImportLeadsApi = (data, header) => api.post('BulkExcelUpload/Upload-Lead', data, header);